// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__7mTDY","topBottomGutter":"Layout_topBottomGutter__2gpB1"};